module.exports = __webpack_public_path__ + "static/media/reports_image4.6e3f6195.webp";